<div class="row g-0 w-100">
  <nav class="navbar navbar-light">
    <a class="back-button d-xs-none d-md-block" style="color: #34343466"
      *ngIf="navigation.isBranchRoute(); else noBranch" (click)="navigation.goBack()"><img
        src="../../../../assets/svg/back-arrow.svg" alt="" style="margin-right: 20px" />
      {{
      navigation.isPay()
      ? "DETALLE DE FACTURACIÓN"
      : role == "Casa Matriz"
      ? " DETALLE SUCURSALES"
      : ""
      }}
    </a>
    <ng-template #noBranch>
      <div></div>
    </ng-template>
    <a [routerLink]="[]" class="my-auto d-block d-md-none d-lg-none me-auto" (click)="showSidebar()">
      <i class="bi bi-filter-right text-size-28px text-default me-3"></i>
    </a>

    <div class="d-flex">
      <div class="d-none pe-xl-3" *ngIf="role == 'Casa Matriz' && type == 'PREPAY'">
        <button class="btn btn btn-dark btn-block" style="height: 52px" [routerLink]="[link]">
          <a [routerLink]="[link]">Cargar mi cuenta </a>
          <img src="assets/svg/plus.svg" alt="" class="my-auto" width="12px" height="13px" />
        </button>
      </div>
      <div class="nav-item dropdown">
        <div class="d-flex flex-row flex-nowrap">
          <div class="user ms-lg-auto">
            <div class="user-name my-auto d-lg-flex d-none">
              <span class="semibold text-size-13px name-position">Hola, {{ user?.personalData?.name || "" }}
                {{ user?.personalData?.lastname || "" }}</span>
              <span class="medium text-size-12px text-light-gray ms-lg-auto">{{
                role == "Casa Matriz"
                ? companyName + " " + role
                : role == "Contratista"
                ? companyName + " " + "Sucursal"
                : role
                }}</span>
            </div>
            <div class="user-img ms-4">
              <img src="{{ image }}" width="45px" height="45px" class="image-profile" />

              <div class="dropdown">
                <button class="drop" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="trues"
                  id="dropdown-profile">
                  <i class="bi bi-chevron-down ms-2"></i>
                </button>
                <div class="dropdown-menu mt-4" aria-labelledby="dropdown-profile">
                  <a class="dropdown-item" [routerLink]="'/profile'">Mis datos</a>
                  <a class="dropdown-item" [routerLink]="'/profile/change-password'">Cambiar Clave</a>
                  <a class="dropdown-item" (click)="logout()">Cerrar sesión <i class="am am-exit my-auto ms-2"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>
